import { BaseDto } from './base.dto';

export class DiscountDto extends BaseDto {
  amount: number;
}
